/* import axios from 'axios';
import i18n from "i18next";

import { confirmDialog } from 'primereact/confirmdialog';

import { AUTHORIZATION } from '@constants/general'

import { cleanStorageAuth } from '@utils/general'

// @Options Object
//  *isFile

const fetchManager  = async (url, options = {}, errorModal = {}) => {
  const { isFile = false } = options
  const config = {
    method: options.method || 'GET',
    url,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      ...options.headers
    },
    data: options.data || null,
    responseType: options.responseType || 'json',
    params: options.params || null
  };

  if (isFile) {
    config.responseType = 'blob'
  }
  
  const { sendToken = true } = options
  if (sendToken) {
    const token = localStorage.getItem(AUTHORIZATION);
    // console.info("Token:[" + token + "]");
    
    if (token) {
      config.headers = Object.assign({}, config.headers, { Authorization: "" })
      config.headers.Authorization = `Bearer ${token}`
    }
  }
  
  return axios(config)
      .then((response) => {
        return ({ data: response.data })
      })
      .catch((error) => {
        console.log('error.data', error)
        let response = {data: { acknowledgementDescription: i18n.t(error.response?.data?.acknowledgementDescription || 'Ha ocurrido un error, inténtelo más tarde.') }, status: error.response?.status || 503 }

        if (response?.status === 401 || response?.status === 403) {
          return redirect()
        }

        // START ERROR MODAL
        const errorConfigModal = {
          show: errorModal?.show === 'no' ? false : true,
          descripction: response.data.acknowledgementDescription,
          title: errorModal?.title || i18n.t('Ha ocurrido un error'),
          textButtonClose: errorModal?.textButtonClose || i18n.t('Cerrar'),
          icon: errorModal?.icon || 'pi-exclamation-triangle'
        }
        if (errorConfigModal.show) {
          confirmDialog({
            message: errorConfigModal.descripction,
            header: errorConfigModal.title,
            icon: `pi ${errorConfigModal.icon}`,
            acceptLabel: errorConfigModal.textButtonClose,
            rejectClassName: 'hide-component',
            accept: () => {},
          });
        }
        // END ERROR MODAL

        return response
    });
}

function redirect() {
  console.log('Entra en redireccionamiento')
  let getUrl = window.location;
  let baseUrl = getUrl.protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[1];
  cleanStorageAuth()
  window.location.href = baseUrl;
}

export default fetchManager */


import axios from 'axios';
import i18n from "i18next";

import { confirmDialog } from 'primereact/confirmdialog';

import { AUTHORIZATION } from '@constants/general';

import { cleanStorageAuth } from '@utils/general';

// Bandera global para evitar múltiples modales simultáneos
let isErrorModalOpen = false;

// @Options Object
//  *isFile

const fetchManager = async (url, options = {}, errorModal = {}) => {
  const { isFile = false, includeBlobAndFileNameHeader = false } = options;

  const config = {
    method: options.method || 'GET',
    url,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      ...options.headers
    },
    data: options.data || null,
    responseType: options.responseType || 'json',
    params: options.params || null
  };

  if (isFile) {
    config.responseType = 'blob';
  }

  const { sendToken = true } = options;

  if (sendToken) {
    const token = localStorage.getItem(AUTHORIZATION);

    if (token) {
      config.headers = Object.assign({}, config.headers, {
        Authorization: `Bearer ${token}`
      });
    }
  }

  return axios(config)
    .then((response) => {
      if (includeBlobAndFileNameHeader === true) {
        return { file: response.data, fileName: response.headers["content-disposition"].split("=")[1] };
      } else {
        return { data: response.data };
      }
    })
    .catch((error) => {
      console.log('error.data', error);

      const response = {
        data: {
          acknowledgementDescription: i18n.t(
            error.response?.data?.acknowledgementDescription ||
            'Ha ocurrido un error, inténtelo más tarde.'
          )
        },
        status: error.response?.status || 503
      };

      if (response?.status === 401 || response?.status === 403) {
        return redirect();
      }

      // START ERROR MODAL
      const errorConfigModal = {
        show: errorModal?.show === 'no' ? false : true,
        descripction: response.data.acknowledgementDescription,
        title: errorModal?.title || i18n.t('Ha ocurrido un error'),
        textButtonClose: errorModal?.textButtonClose || i18n.t('Cerrar'),
        icon: errorModal?.icon || 'pi-exclamation-triangle'
      };

      if (errorConfigModal.show && !isErrorModalOpen) {
        isErrorModalOpen = true;

        confirmDialog({
          message: errorConfigModal.descripction,
          header: errorConfigModal.title,
          icon: `pi ${errorConfigModal.icon}`,
          acceptLabel: errorConfigModal.textButtonClose,
          rejectClassName: 'hide-component',
          accept: () => {
            isErrorModalOpen = false;
          },
          onHide: () => {
            isErrorModalOpen = false;
          }
        });
      }
      // END ERROR MODAL

      return response;
    });
};

function redirect() {
  console.log('Entra en redireccionamiento');

  let getUrl = window.location;
  let baseUrl = getUrl.protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[1];

  cleanStorageAuth();

  window.location.href = baseUrl;
}

export default fetchManager;